export const fileFormats = [
  { id: "pdf", name: "PDF" },
  { id: "doc", name: "DOC" },
  { id: "docx", name: "DOCX" },
  { id: "xls", name: "XLS" },
  { id: "xlsx", name: "XLSX" },
  { id: "ppt", name: "PPT" },
  { id: "pptx", name: "PPTX" },
  { id: "txt", name: "TXT" },
  { id: "csv", name: "CSV" },
  { id: "jpg", name: "JPG" },
  { id: "jpeg", name: "JPEG" },
  { id: "png", name: "PNG" },
  { id: "gif", name: "GIF" },
  { id: "svg", name: "SVG" },
  { id: "webp", name: "WEBP" },
  { id: "mp4", name: "MP4" },
  { id: "mp3", name: "MP3" },
  { id: "zip", name: "ZIP" },
  { id: "rar", name: "RAR" },
  { id: "7z", name: "7Z" },
  { id: "json", name: "JSON" },
  { id: "xml", name: "XML" },
  { id: "html", name: "HTML" },
  { id: "css", name: "CSS" },
  { id: "js", name: "JS" }
];

export const imageFormats = [
  { id: "jpg", name: "JPG" },
  { id: "jpeg", name: "JPEG" },
  { id: "png", name: "PNG" },
  { id: "gif", name: "GIF" },
  { id: "svg", name: "SVG" },
  { id: "webp", name: "WEBP" }
];

export const ocrFormats = [
  { id: "pdf", name: "PDF" },
  { id: "jpg", name: "JPG" },
  { id: "jpeg", name: "JPEG" },
  { id: "png", name: "PNG" },
  { id: "webp", name: "WEBP" }
];
